module.exports = __webpack_public_path__ + "img/success-reg.d13bbeb1.png";